// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Q8rL","dragIcon":"SortableItem_dragIcon__2jPBK","disabled":"SortableItem_disabled__7yvgM"};